import config from '../../../config';
import { formatLocalDate } from '../../../utils/date/dateUtils';
import { getData } from 'src/utils/axios/serverHelper';
import { 
  DashboardProductResultDto,
  DashboardMainTopDto,
  DashboardKpiHistoryDto,
  DashboardProductionDetailDto,
  DashboardKpiSendDetailDto,
  DashboardProcessMonitoringDto,
  DashboardProcessInstructionDto
} from './Dto_Home';

const BASE_URL = `${config.apiUrl}/dashboard`;

const getParams = (startDate: Date, endDate: Date) => {
  const startDateStr = formatLocalDate(startDate);
  const endDateStr = formatLocalDate(endDate);
  return {
    startDate: startDateStr,
    endDate: endDateStr,
  };
};

// 백엔드 /main-top - 대시보드 KPI 요약 조회 
export const getMainTop = async (startDate: Date, endDate: Date) => {
  return await getData<DashboardMainTopDto>(`${BASE_URL}/main-top`, {
    params: getParams(startDate, endDate)
  });
};

// 백엔드 /monthly-production - 브랜드별 생산 실적 현황 (혼합 차트용)
export const getMonthlyProduction = async (startDate: Date, endDate: Date) => {
  return await getData<DashboardProductResultDto[]>(`${BASE_URL}/monthly-production`, {
    params: getParams(startDate, endDate)
  });
};

// 백엔드 /itemgroup-production - 월별 불량현황(바 차트) + 품목그룹별 생산실적(도넛 차트)
export const getItemGroupProduction = async (startDate: Date, endDate: Date) => {
  return await getData<DashboardProductResultDto[]>(`${BASE_URL}/itemgroup-production`, {
    params: getParams(startDate, endDate)
  });
};

// 백엔드 /kpi-history - KPI 전송현황 (도넛 차트용)
export const getKpiHistory = async (startDate: Date, endDate: Date) => {
  return await getData<DashboardKpiHistoryDto[]>(`${BASE_URL}/kpi-history`, {
    params: getParams(startDate, endDate)
  });
};

// 백엔드 /production-details - 상세 생산실적 (테이블용)
export const getProductionDetails = async (startDate: Date, endDate: Date) => {
  return await getData<DashboardProductionDetailDto[]>(`${BASE_URL}/production-details`, {
    params: getParams(startDate, endDate)
  });
};

// 백엔드 /kpi-send-detail - KPI 전송내역 (테이블용)
export const getKpiSendDetail = async (startDate: Date, endDate: Date) => {
  return await getData<DashboardKpiSendDetailDto[]>(`${BASE_URL}/kpi-send-detail`, {
    params: getParams(startDate, endDate)
  });
};

// 공정 실적 모니터링
export const getProcessMonitoring = async (compCd: string, searchDate?: string) => {
  return await getData<DashboardProcessMonitoringDto[]>(`${BASE_URL}/process-monitoring`, {
    params: { compCd, searchDate }
  });
};

// 공정 지시내역
export const getProcessInstructions = async (compCd: string, startDate?: string, endDate?: string) => {
  return await getData<DashboardProcessInstructionDto[]>(`${BASE_URL}/process-instructions`, {
    params: { compCd, startDate, endDate }
  });
};